import type { RiskAssessmentResultConfig } from '@risksmart-app/domain/src/types';
import type { UpdateRiskAssessmentResultConfigMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetLatestRiskAssessmentResultConfigDocument,
  GetRiskAssessmentResultConfigByIdsDocument,
  UpdateRiskAssessmentResultConfigDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateRiskAssessmentResultConfigInput = {
  variables: {
    Id: string;
    Config: RiskAssessmentResultConfig;
    OriginalTimestamp: string;
  };
};

export const useUpdateRiskAssessmentResultConfig = createMutationHook({
  name: 'mutate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.riskAssessmentResultConfig.update.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateRiskAssessmentResultConfigInput) => ({
    Id: input.variables.Id,
    Config: input.variables.Config,
    OriginalTimestamp: input.variables.OriginalTimestamp,
  }),
  invalidate: (trpc) => [
    trpc.frontend.riskAssessmentResultConfig.getLatest.queryKey(),
    trpc.frontend.riskAssessmentResultConfig.getByIds.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
    Version: number;
    IsLatest: boolean;
  }): UpdateRiskAssessmentResultConfigMutation => ({
    updateRiskAssessmentResultConfigApi: {
      __typename: 'UpdateRiskAssessmentResultConfigApiOutput',
      Id: result.Id,
      Version: result.Version,
      IsLatest: result.IsLatest,
    },
  }),
  graphqlDocument: UpdateRiskAssessmentResultConfigDocument,
  graphqlVariables: (input: UpdateRiskAssessmentResultConfigInput) => ({
    ...input.variables,
  }),
  refetchQueries: [
    {
      query: GetLatestRiskAssessmentResultConfigDocument,
      variables: { Type: 'risk_assessment' },
    },
    { query: GetRiskAssessmentResultConfigByIdsDocument },
  ],
});
